import LoginForm from "../components/LoginForm";
import "../styles/root.scss";
import { useEffect } from "react";

const Login = () => {
  useEffect(() => {
    // localStorage.clear();
  }, []);

  return <LoginForm />;
};

export default Login;
